/* eslint-disable no-console */
import { isDebug } from '@core/debug'
import {
  debugInfoGradient,
  logError,
  safeConsoleDir,
  safeConsoleGroupCollapsed,
  safeConsoleGroupEnd,
  safeConsoleTable,
} from '@core/logging/helpers'

/**
 * Console log for resolved params
 */
export function debugParams(
  paramsSource: Record<string, Record<string, any> | undefined>,
  resolvedParams: Record<string, any>,
) {
  if (!isDebug()) {
    return
  }

  try {
    const customElement = `fw-` + resolvedParams.type?.replace('_', '-')
    const element =
      Array.from(document.querySelectorAll(customElement)).find(
        (el) => el['widgetId'] === resolvedParams.widget_id,
      ) || resolvedParams.target

    safeConsoleGroupCollapsed(
      `%cFW-DEBUG <${customElement}> (${resolvedParams.widget_id})`,
      debugInfoGradient,
    )

    console.log('Matched elements:', element)
    safeConsoleDir(element)

    console.log('---')

    let styleMap: any[]

    try {
      styleMap = (element as any).computedStyleMap() ?? []
    } catch {
      styleMap = []
    }

    const cssVars: any = Array.from(styleMap).filter(([prop]) =>
      prop.startsWith('--fw-'),
    )
    safeConsoleGroupCollapsed('CSS Variables:', cssVars.length)
    safeConsoleTable(
      cssVars
        .map(([prop, value]) => [prop, `${value}`])
        .sort((a, b) => a[0].localeCompare(b[0])),
    )
    safeConsoleGroupEnd()

    console.log('---')

    const arrayOfParams = [
      ...Object.keys(paramsSource).map((key) => [key, paramsSource[key]]),
      ['= Resolved params:', resolvedParams],
    ]

    arrayOfParams.forEach(([title, params]) => {
      safeConsoleGroupCollapsed(
        `${title} (${Object.values(params ?? {}).length})`,
      )
      if (params && Object.values(params).length) {
        safeConsoleTable(
          Object.entries(params)
            .map(([key, value]) => [key, `${value}`])
            .sort((a, b) => a[0].localeCompare(b[0])),
        )
      }
      safeConsoleGroupEnd()
    })

    safeConsoleGroupEnd()
  } catch (e) {
    logError(e)
  }
}
